import { combineReducers } from 'redux';
import excelOptions from './downloadExcelOptionsReducer';
import csvOptions from './downloadCsvOptionsReducer';

export default combineReducers({
    excelOptions,
    csvOptions,
});
